import * as HttpService from "../../../../service/HttpService";

/**
 * 查询终端管理列表
 */
export const queryAllocationList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/electricity/queryAllocationList",params);
};

/**
 * 新增终端
 */
export const addAllocation = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/electricity/addAllocation", params);
};

/**
 * 新增终端
 */
export const editAllocation = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/electricity/editAllocation", params);
};

/**
 * 根据用电单位获取间隔
 */
export const getDevice = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/electricity/getDevice?uintId="+params);
};
